import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import system from "./modules/system"; //system 정보관리를 위한 store
import manageUI from "./modules/manageUI"; //ui관리를 위한 store
import customer from "./modules/customer"; //고객관리를 위한 store
import survey from "./modules/survey"; //만족도 조사를 위한 store
import document from "./modules/document"; //서류제출을 위한 store

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    system,
    manageUI,
    customer,
    survey,
    document
  }
});
